
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yoga",
      function () {
        return require("private-next-pages/yoga.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yoga"])
      });
    }
  